export default function NotFoundPage() {
	return (
		<div>
			<h1>404 Not Found</h1>
			<p>ページが見つかりませんでした。</p>
		</div>
	)
}
